import { EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { Type } from '@angular/core';

export class CustomGridSettings {
    totalRows: number;
    totalNotSubmitedRows: number;
    editTooltip: string;
    removeTooltip: string;
    copyTooltip: string;
    title: string;
    countTitle: string;
    isApprovals: boolean;
    allowSubmit: boolean;
    canSubmitAll: boolean;
    showSearch: boolean;
    allowDownloadFile: boolean;
    allowPrint: boolean;
    showDuplicate: boolean;
    isMultipleNotAddingUp: boolean;
    showErrorSearch: boolean;
    removePageSizeRange: boolean;
    hideColumns: string[];
    keydownInputSearch: boolean;
    showColumnFilters: boolean;
    onChangeGrid: EventEmitter<any>;
    onRemoveItem: EventEmitter<any>;
    onEditItem: EventEmitter<any>;
    onCopyItem: EventEmitter<any>;
    onDownloadFile: EventEmitter<any>;
    onPrint: EventEmitter<any>;
    onEditCell: EventEmitter<any>;
    onApprovedAll: EventEmitter<any>;
    onApprovedSelected: EventEmitter<any>;
    onSubmitAll: EventEmitter<any>;
    onSubmitSelected: EventEmitter<any>;
    onSave: EventEmitter<any>;
    onRevalidate: EventEmitter<any>;
    onDuplicate: EventEmitter<any>;
    onRowClick: EventEmitter<any>;
    onOpenSelect: EventEmitter<any>;
    isEditable: ((item: any) => boolean);
    allowDuplicate: ((item: any) => boolean);
    rowData: any[];
    columnDefs: ColumnsDefinition[];
    events: GridEvent[];
    state: GridState;
}

export class GridState {
    pageNumber: number;
    pageSize: number;
    searchBy: string;
    qrySearch: string;
    orderBy: string;
    asc: boolean;
    data?: any;
}


export enum FieldType {
    Image = 1,
    Text = 2,
    Date = 3,
    Number = 4,
    Decimal = 5,
    Dropdown = 6,
    CheckBox = 7,
    RadioButton = 8,
    Custom = 9,
    Currency = 10
}
export class ColumnsDefinition {
    field: string;
    filter: boolean;
    headerName: string;
    sortProperty?: string;
    headerStyleClass: string;
    displayProperty: string;
    styleClass?: string;
    dateFormat: string;
    fieldType: FieldType;
    customFieldTypeDef: Type<any>;
    customFieldTypeArgs: string;
    dataSource: DataSource;
    isEditable: boolean | ((item: any) => boolean);
    isValid: (value: any, col: any) => boolean;
    isVisible: boolean | (() => boolean);
    showActionIcon: boolean;
    actionIconClass: string;
    isPrintable: boolean;
    totalizer: boolean;
    showActionIconFunc: ((item: any) => boolean);
    clickActionIconFunc: ((item: any) => void);
}

export  class GridEvent {
    event: EventEmitter<any>;
    icon: string;
    buttonClass: string;
    label: string;
    toolTip: string;
    isVisible: boolean | ((item: any) => boolean);
    isDisable: boolean | ((item: any) => boolean);
}


export class DataSource {
    private _data$;
    private _onchange$;
    private _settings;
    value: string;
    label: string;
    constructor(){};
    // get onChange(): Observable<any[]> {

    // };
    // set data(data: Observable<any[]>);
    // get data$(): Observable<any[]>;
    // set settings(setting: any);
    // get settings(): any;
    // change(item: any): void;
}
